export const FIELD_SUGGESTIONS_SOURCE = {
	LABELS_DROPDOWN: 'field_suggestions_labels_dropdown' as const,
	API_CALL: 'field_suggestions_api_call' as const,
};

type FieldSuggestionSource =
	(typeof FIELD_SUGGESTIONS_SOURCE)[keyof typeof FIELD_SUGGESTIONS_SOURCE];

export const getFieldSuggestionAiAttributes = (
	singleInstrumentationID: string,
	// TODO: When we extend field suggestions to other fields, we should update the default value/make it a required variable
	invokedFrom: FieldSuggestionSource = FIELD_SUGGESTIONS_SOURCE.LABELS_DROPDOWN,
) => {
	return {
		aiFeatureName: 'jiraFieldSuggestions',
		userGeneratedAI: 0,
		proactiveAIGenerated: 1,
		isAIFeature: 1,
		singleInstrumentationID,
		// TODO: Make this more modular when we suggest more field types
		fieldSuggestionType: 'labels',
		invokedFrom,
	};
};
